import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';

const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

const buildUrl = (name) => (baseUrl ? `${baseUrl}/${name}` : null);

const parseCallableResponse = async (response) => {
  const json = await response.json();
  const data = json?.data ?? json?.result ?? null;
  return { data };
};

export const callFunction = async (name, payload, getAccessToken) => {
  const url = buildUrl(name);
  if (url) {
    const accessToken = getAccessToken ? await getAccessToken() : null;
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
      body: JSON.stringify({ data: payload || {} }),
    });

    if (!res.ok) {
      throw new Error(`Function call failed: ${res.status} ${res.statusText}`);
    }

    return parseCallableResponse(res);
  }

  // Fallback to Firebase SDK callable if no base URL is configured.
  return httpsCallable(functions, name)(payload);
};
